<template>
  <span class="text-purple-ap-100 font-light">
    {{ parseInt(fullHours) > 0 ? fullHours : "No Childcare Experience" }}
  </span>
</template>

<script>
export default {
  name: "ChildCareHours",
  props: ["aupair"],
  computed: {
    fullHours() {
      return `${this.aupair.childcareExperienceUnder1 +
        this.aupair.childcareExperienceUpTo2 +
        this.aupair.childcareExperienceUpTo5 +
        this.aupair.childcareExperienceUpTo10 +
        this.aupair.childcareExperienceOver10} Childcare Hours`;
    },
  },
};
</script>
